module.exports = {
  blogPostDir: "posts", // The name of directory that contains your posts.
  videoPostDir: "videos",
  blogPostSort: "date", // which field on the post to sort by
  videoPageSize: 32, // size of pages of video posts
  blogPageSize: 16, // size of pages of blog posts
  algoliaApplicationID: "RP13G16DUX", // unique application identifier used to identify you when using Algolia's API.
  algoliaSearchOnlyAPIKey: "059b74db59efbd3833aa08ab1bc1bec0", // public API key to use in your frontend code. This key is only usable for search queries.
  algoliaIndexName: "oncezone",
  algoliaDevIndexName: "dev_oncezone",
  algoliaDisableIndexing: false, // set this to true if you want to disable algolia indexing when building, useful if you don't have an admin key
  paginatedPathPrefix: "", //
  dateFormatInput: "YYMMDD", // date format to use for parsing from source
  dateFormatOutput: "YYMMDD", // date format to use for output/rendering, see http://momentjs.com/docs/#/displaying/format/
  siteTitle: "Once Zone", // Site title.
  siteTitleAlt: "OnceZone", // Alternative site title for SEO.
  siteLogo: "/logos/logo-large.png", // Logo used for SEO and manifest.
  siteUrl: "https://once.zone", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: "Provides contents for ONCE by ONCE.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: "", // FB Application ID for using app insights
  googleAnalyticsID: "", // GA tracking ID.
  disqusShortname: "", // Disqus shortname.
  postDefaultCategoryID: "Tech", // Default category for posts.
  userName: "OnceZone", // Username to display in the author segment.
  userTwitter: "OnceZone", // Optionally renders "Follow Me" in the UserInfo segment.
  // userLocation: "North Pole, Earth", // User location to display in the author segment.
  // userAvatar: "https://api.adorable.io/avatars/150/test.png", // User avatar to display in the author segment.
  // userDescription: "",
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: [
    {
      label: "GitHub",
      url: "https://github.com/Vagr9K/gatsby-advanced-starter",
      iconClassName: "fa fa-github"
    },
    {
      label: "Twitter",
      url: "https://twitter.com/Vagr9K",
      iconClassName: "fa fa-twitter"
    },
    {
      label: "Email",
      url: "mailto:vagr9k@gmail.com",
      iconClassName: "fa fa-envelope"
    }
  ],
  // copyright: "Copyright © 2017. Advanced User", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#EB82A2", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0" // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js